export default __webpack_public_path__ + "static/media/ic_success.75644464.png";